import React, { useEffect } from 'react';
import { View, ActivityIndicator, Text, Platform, StyleSheet } from 'react-native';
import { getApiUrl } from '../utils/apiConfig';

/**
 * Same-origin popup entry for YouTube OAuth (opens in a small window, then redirects to API → Google).
 * Keeps window.opener attached to the main app tab on production hosts.
 */
export default function YoutubeOAuthBridgePage() {
  useEffect(() => {
    if (Platform.OS !== 'web' || typeof window === 'undefined') return;

    const params = new URLSearchParams(window.location.search);
    const accountKey = params.get('account_key') || 'default';
    const returnTo = params.get('return_to') || '';
    const forceConsent = params.get('force_consent') === '1';

    const q = new URLSearchParams({
      account_key: accountKey,
      popup: '1',
    });
    if (returnTo) q.set('return_to', returnTo);
    if (forceConsent) q.set('force_consent', '1');

    const api = getApiUrl().replace(/\/$/, '');
    window.location.replace(`${api}/api/youtube/oauth/start?${q.toString()}`);
  }, []);

  return (
    <View style={styles.wrap}>
      <ActivityIndicator size="large" color="#d4af37" />
      <Text style={styles.text}>Redirecting to Google…</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#000',
    gap: 16,
  },
  text: {
    color: '#fff',
    fontSize: 15,
  },
});
